import { API_URL } from "../../utils/contextHelpers";
import { api } from "./core";

export const grabarContacto = api("grabarContacto", (codigo, email, id, nombre, telefono) =>
    `${API_URL}contactos/grabar?codigo=${codigo}&email=${email}&id=${id}&nombre=${nombre}&telefono=${telefono}`
);

export const getContactosCliente = api("getContactosCliente", (codigo) => `${API_URL}contactos/cliente?codigo=${codigo}`);

export const AsociarContactoCliente = api("AsociarContactoCliente", (id_contacto, codigo_cliente) => `${API_URL}contactos/asociar?id=${id_contacto}&codigo=${codigo_cliente}`);
